import R from "ramda";
import { store } from "store";
import axios from "axios";
import { redirectToLoginAction } from "actions/oauth-actions";
import { globalErrorAction } from "actions/app-actions";

const authToken = () => R.path(["oauth", "token"], store.getState());

const instance = () => axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${authToken()}`,
    "Content-Type": "application/json"
  }
});

const formDataInstance = (url) => axios.create({
  baseURL: url,
  headers: {
    Accept: "application/json",
    Authorization: `Bearer ${authToken()}`,
    "Content-Type": "multipart/form-data"
  }
});

const nonAjaxPost = (url, data) => {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = url;
  form.setAttribute("style", "width: 0px; height: 0px");

  const keys = Object.keys(data);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];

    if (data[key]) {
      const inputElement = document.createElement("input");
      inputElement.setAttribute("name", key);
      inputElement.setAttribute("value", data[key]);
      form.appendChild(inputElement);
    }
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const http = {
  get: (path) => (instance().get(path)).catch(errorCatcher),
  post: (path, data) => (instance().post(path, data)).catch(errorCatcher),
  put: (path, data) => (instance().put(path, data)).catch(errorCatcher),
  delete: (path) => (instance().delete(path)).catch(errorCatcher),
  upload: (path, data) => (formDataInstance(API_BASE_URL).post(path, data).catch(errorCatcher)),
  nonAjaxPost
};

const errorCatcher = (err) => {
  const status = R.path(["response", "status"], err);

  /* TODO this is a temporary fix due to an issue where 401 responses from the API
   * are not compatible with CORS. It's impossible to read the response in JavaScript,
   * so for now, assume all network errors are 401s */
  if (status === undefined) {
    return store.dispatch(redirectToLoginAction());
  }

  if (status >= 500) {
    return store.dispatch(globalErrorAction());
  }

  return Promise.reject(err);
};



// WEBPACK FOOTER //
// ./src/js/api/http.js